<template>
  <Drawer
    :id="drawerId"
    :width="$vuetify.breakpoint.mobile ? '100%' : '90%'"
    class="greyLight"
  >
    <div class="white h-full">
      <ProjectPreviewCarousel
        v-if="project"
        :key="project.id"
        class="rounded-0"
        :project="project"
        full-height
      />
    </div>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { DRAWERS } from '@/utils/constants';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import ProjectPreviewCarousel from '../../components/projects/ProjectPreviewCarousel';

export default {
  name: 'ProjectProofDrawer',

  components: {
    ProjectPreviewCarousel,
    Drawer
  },

  data() {
    return {
      show: false,
      project: null,
      drawerId: DRAWERS.PROJECT_PROOF
    };
  },

  computed: {
    ...mapGetters({
      initialData: 'drawers/data',
      top_drawer: 'drawers/topDrawer',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },
  watch: {
    drawerOpenedAt(val, oldVal) {
      if (this.drawerId === this.top_drawer?.id) {
        const initial = this.initialData(this.drawerId) || {};
        this.project = cloneDeep(initial.project);
        if (initial.projectId) {
          this.$api.get(`project/detail/${initial.projectId}`).then((response) => {
            this.project = response.data;
          });
        }
      }
    }
  },

  methods: {
    cancel() {
      this.$store.commit('drawers/CLOSE_DRAWER', this.drawerId);
    }
  }
};
</script>

<style></style>
